import { useLayoutContext } from 'contexts/LayoutContext';
import PageLoader from 'components/PageLoader';
import GridContainer from 'components/GridContainer';
import { Divider, Grid } from '@mui/material';
import OverallEqualisationInterestSettings from './OverallEqualisationInterestSettings';
import FormWrapper, { EqualisationSettingsFormValues } from './FormWrapper';
import { useFormContext } from 'react-hook-form';
import EqualisationInterestFeeTemplates from './EqualisationInterestFeeTemplates';
import Button from 'components/Button';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { Column, Row } from 'further-ui/components/Layout';
import FullHeightView from 'components/new/FullHeightView';

const EqualisationInterestForm: React.FC<{ vehicleId: string }> = ({
  vehicleId,
}: {
  vehicleId: string;
}) => {
  const { handleSubmit } = useFormContext<EqualisationSettingsFormValues>();
  const mutationOpts = useHandleTrpcMutation();
  const updateEqualisationInterestSettings =
    api.vehicle.updateEqualisationInterestSettings.useMutation(
      mutationOpts({
        successMessage: 'Equalisation interest settings updated.',
      }),
    );

  const onSubmit = (data: EqualisationSettingsFormValues) => {
    const { dayCount, equalisationInterestFeeTemplates } = data;
    updateEqualisationInterestSettings.mutate({
      vehicleId,
      dayCount,
      equalisationInterestFeeTemplates,
    });
  };

  return (
    <FullHeightView
      actionBar={
        <Row fullWidth justify="flex-end">
          <Button
            type="submit"
            form="equalisation-form"
            variant="contained"
            color="primary"
            size="large"
            loading={updateEqualisationInterestSettings.isPending}
          >
            Save settings
          </Button>
        </Row>
      }
    >
      <form id="equalisation-form" onSubmit={handleSubmit(onSubmit)}>
        <GridContainer>
          <Grid size={{ xs: 12, xl: 8 }}>
            <Column fullWidth spacing="lg">
              <OverallEqualisationInterestSettings />
              <Divider />
              <EqualisationInterestFeeTemplates />
            </Column>
          </Grid>
        </GridContainer>
      </form>
    </FullHeightView>
  );
};

const EqualisationInterest: React.FC = () => {
  const { vehicle } = useLayoutContext();

  if (!vehicle) return <PageLoader />;

  return (
    <FormWrapper values={vehicle.equalisationSettings}>
      <EqualisationInterestForm vehicleId={vehicle._id} />
    </FormWrapper>
  );
};

export default EqualisationInterest;
